<script>
import { authComputed } from "@/state/helpers";
import MultiSelect from "vue-multiselect";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import hkService from "@/helpers/APIService/hk.service";

export default {
  name: "staff_health_que_ans",
  props: {
    currentProps: Object,
  },
  components: {
    MultiSelect,
  },
  data() {
    return {
      staffHealthQuestions: [],
      staffName: "",
      errorMessage: "",
      errorStatusCode: "",
      staffHealthSheetId: "",
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getStaffHealthQuestionAnswerList();
  },
  methods: {
    async getStaffHealthQuestionAnswerList() {
      hkService
        .getStaffHealthSheetQuestionList(
          this.currentProps.staffHelthSheetData.Id
        )
        .then((response) => {
          this.staffHealthQuestions =
            response.staff_health_sheet_question_answer;
          this.staffHealthSheetId = response.id;
          this.staffName = response.staff_user.name;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    updateAnswer(value, id, status) {
      let data = [];
      let multi_select_values = [];
      if (status == "multiSelect") {
        value.map((item) => {
          multi_select_values.push(item.option);
        });
        value = multi_select_values;
      }
      data.push({
        id: id,
        answer_text: value,
      });
      if (data[0].answer_text !== undefined) {
        hkService
          .updateStaffHealthSheetQuestionAnswer(this.staffHealthSheetId, data)
          .then(() => {
            Middleware.notification(
              "Answer changed successfully !!",
              "success",
              3000
            );
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="alert alert-secondary">
      <div class="row" v-if="errorStatusCode === ''">
        <div class="col-md-6">
          <h5 class="text-dark mb-2"><b>Health Sheet</b></h5>
          <div class="d-flex">
            <p class="mb-0 text-dark">Date :</p>
            <span class="text-dark ms-2">{{
              global_format_date(this.currentProps.staffHelthSheetData.date)
            }}</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="text-end">
            <h5 class="text-dark"><b>Staff Name</b></h5>
            <p class="text-dark mb-0">{{ staffName }}</p>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div
      v-for="(question, index) in staffHealthQuestions"
      :key="index"
      :class="index == 0 ? 'row' : ''"
    >
      <div class="col-md-12 mb-3">
        <h5 class="card-title mt-0 p-1">
          {{ index + 1 }}.
          {{ question.question_text }}
          <span class="text-danger" v-if="question.is_required">*</span>
        </h5>
        <div v-if="question.answer_type == 'text'">
          <input
            type="text"
            autocomplete="off"
            class="form-control"
            :readonly="!question.is_editable"
            :required="question.is_required"
            :name="question.id"
            :value="question.answer_text"
            @focusout="updateAnswer($event.target.value, question.id)"
          />
        </div>
        <div v-else-if="question.answer_type == 'date'">
          <input
            type="date"
            class="form-control"
            :name="question.id"
            :readonly="!question.is_editable"
            :required="question.is_required"
            :value="question.answer_text"
            @change="updateAnswer($event.target.value, question.id)"
          />
        </div>
        <div v-else-if="question.answer_type == 'time'">
          <input
            type="time"
            class="form-control"
            :name="question.id"
            :readonly="!question.is_editable"
            :required="question.is_required"
            :value="question.answer_text"
            @change="updateAnswer($event.target.value, question.id)"
          />
        </div>
        <div v-else-if="question.answer_type == 'tel'">
          <input
            type="tel"
            autocomplete="off"
            class="form-control"
            :name="question.id"
            :readonly="!question.is_editable"
            :required="question.is_required"
            :value="question.answer_text"
            @focusout="updateAnswer($event.target.value, question.id)"
          />
        </div>
        <div v-else-if="question.answer_type == 'email'">
          <input
            type="email"
            autocomplete="off"
            class="form-control"
            :name="question.id"
            :readonly="!question.is_editable"
            :required="question.is_required"
            :value="question.answer_text"
            @focusout="updateAnswer($event.target.value, question.id)"
          />
        </div>
        <div v-else-if="question.answer_type == 'number'">
          <input
            type="number"
            autocomplete="off"
            class="form-control"
            :name="question.id"
            :readonly="!question.is_editable"
            :required="question.is_required"
            :value="question.answer_text"
            @focusout="updateAnswer($event.target.value, question.id)"
          />
        </div>
        <div v-else-if="question.answer_type == 'phone'">
          <input
            type="tel"
            autocomplete="off"
            class="form-control"
            :name="question.id"
            :readonly="!question.is_editable"
            :required="question.is_required"
            :value="question.answer_text"
            @focusout="updateAnswer($event.target.value, question.id)"
          />
        </div>
        <div v-else-if="question.answer_type == 'long_text'">
          <textarea
            class="form-control"
            placeholder="Your Answer"
            cols="30"
            rows="3"
            :readonly="!question.is_editable"
            :required="question.is_required"
            :value="question.answer_text"
            @focusout="updateAnswer($event.target.value, question.id)"
          ></textarea>
        </div>
        <div v-else-if="question.answer_type == 'radio'" class="ml-2">
          <div class="radio radio-single">
            <input
              type="radio"
              value="Yes"
              :name="question.id"
              :readonly="!question.is_editable"
              :required="question.is_required"
              :checked="question.answer_text"
              @change="updateAnswer($event.target.value, question.id)"
            />
            <label class="ms-2"> Yes </label>
          </div>
          <div class="radio radio-success radio-single mt-1">
            <input
              type="radio"
              value="No"
              :name="question.id"
              :readonly="!question.is_editable"
              :required="question.is_required"
              :checked="question.answer_text"
              @change="updateAnswer($event.target.value, question.id)"
            />
            <label class="ms-2">No</label>
          </div>
        </div>
        <div v-else-if="question.answer_type == 'choice'">
          <div
            class="checkbox mb-2"
            v-for="(option, index) in question.form_data"
            :key="index"
          >
            <input
              :id="question.id + '_option_' + index"
              type="checkbox"
              :name="question.id"
              :value="question.answer_text"
              @click="updateAnswer($event.target.value, question.id)"
            />
            <label :for="question.id + '_option_' + index" class="ms-2">
              {{ option.option }}
            </label>
          </div>
        </div>
        <div v-else-if="question.answer_type == 'multi_select'" class="ml-2">
          <!-- <div
            class="checkbox mb-2"
            v-for="(option, index) in question.form_data"
            :key="index"
          > -->
          <MultiSelect
            v-model="question.answer_text"
            :options="question.form_data"
            :show-labels="false"
            track-by="option"
            label="option"
            :required="question.is_required"
            :id="index"
            :multiple="true"
            ref="question"
            @input="
              updateAnswer(question.answer_text, question.id, 'multiSelect')
            "
          />
          <!-- <input
              :id="question.id + '_option_' + index"
              type="select"
              :name="question.id"
              :readonly="!question.is_editable"
              :required="question.is_required"
              :value="question.answer_text"
              @click="updateAnswer($event.target.value, question.id)"
              ref="question"
              multiple
            />
            <label :for="question.id + '_option_' + index" class="ms-2">
              {{ option.option }}
            </label> -->
          <!-- </div> -->
        </div>
        <div v-else-if="question.answer_type == 'file'">
          <input
            type="file"
            class="form-control"
            :name="question.id"
            :readonly="!question.is_editable"
            :required="question.is_required"
            :src="question.answer_text"
            @change="updateAnswer($event.target.value, question.id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
